import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.3809 5.38086C14.7226 5.03915 15.2774 5.03915 15.6191 5.38086C15.9608 5.72257 15.9608 6.27743 15.6191 6.61914L10.2383 12L15.6191 17.3809C15.9608 17.7226 15.9608 18.2774 15.6191 18.6191C15.2774 18.9608 14.7226 18.9608 14.3809 18.6191L8.38086 12.6191C8.03915 12.2774 8.03915 11.7226 8.38086 11.3809L14.3809 5.38086Z",
		fill: "currentColor"
	})
});
export default SvgChevronLeft;
